import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from './TextField';

const Select = ({
  options = [],
  ...rest
}) => {
  return (
    <TextField {...rest} select>
      {options.map(option => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
    </TextField>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Warehouses/Select.jsx